import '@fontsource-variable/plus-jakarta-sans';
import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { reloadForUpdate } from './lib/app-update';
import { Providers } from './providers';
import { createAppRouter } from './router';

// Vite: a file of the old version could not be loaded after a deploy → the new version, once.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForUpdate()) event.preventDefault();
});

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={createAppRouter()} />
    </Providers>
  </StrictMode>,
);
